import { ChevronDownIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import { ReactNode, useState } from "react";

interface ChatListSectionProps {
  title: string;
  badgeCount: number;
  defaultOpen?: boolean;
  loading?: boolean;
  isEmpty?: boolean;
  onToggle?: (isOpen: boolean) => void;
  children: ReactNode;
}

export function ChatListSection({
  title,
  badgeCount,
  defaultOpen = false,
  loading = false,
  isEmpty = false,
  onToggle,
  children,
}: ChatListSectionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const toggle = () => {
    setIsOpen((prev) => {
      const next = !prev;
      onToggle?.(next);
      return next;
    });
  };

  return (
    <div>
      <button
        type="button"
        onClick={toggle}
        className="flex w-full items-center gap-2 px-4 py-2.5 text-left"
      >
        {isOpen ? (
          <ChevronDownIcon className="size-3.5 text-text-secondary" />
        ) : (
          <ChevronRightIcon className="size-3.5 text-text-secondary" />
        )}
        <span className="text-[13px] font-semibold tracking-[-0.08px] text-text-secondary">
          {title}
        </span>
        {badgeCount > 0 ? (
          <span className="text-xs text-text-tertiary">
            {badgeCount > 99 ? "99+" : badgeCount}
          </span>
        ) : null}
      </button>
      {isOpen ? (
        loading ? (
          <div className="space-y-2 px-4 py-2">
            <div className="h-12 animate-pulse rounded bg-surfaces-z4" />
            <div className="h-12 animate-pulse rounded bg-surfaces-z4" />
          </div>
        ) : isEmpty ? (
          <p className="px-6 pb-4 pt-1 text-xs text-[#c4bfb6]">
            No conversations
          </p>
        ) : (
          children
        )
      ) : null}
    </div>
  );
}
